import React from 'react';
import clx from 'classnames';

type AppProps = {
  className?: string;
};

const Enterprise: React.FC<AppProps> = ({ className = 'h-8' }) => {
  return (
    <div className={clx('flex items-center')}>
      <img src={require('./enterprise.png')} className={className} />
    </div>
  );
};

export default Enterprise;
